import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Checkbox, Container, FormControlLabel, Grid, IconButton, Modal, TextField, Tooltip, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import { MdAdd, MdEdit, MdEditSquare, MdOutlineRemove } from "react-icons/md";
import { ContextNotification, severitys } from '../../../App';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import roomApi from '../../../api/roomApi';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import floorApi from '../../../api/floorApi';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import BedCountCircles from '../../../Components/BedCountCircles';
import hotelStructureApi from '../../../api/hotelStructureApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import Loading from '../../../Components/Loading';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import enumMapper from '../../../enumMapper';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const tableStyle = {
    border: 'solid 1px #ddd'
}
const AutoDesignHotel = () => {
    const { open, setOpen } = useContext(ContextNotification);
    const [Cities, setCities] = useState([]);
    const [Hotels, setHotels] = useState([]);
    const [hotelStructureIds, setHotelStructureIds] = useState([])
    const [HotelStructure, SetHotelStructure] = useState(null);

    const [openFloorDelete, setOpenFloorDelete] = useState(false);
    const [deleteFloorData, setDeleteFloorData] = useState({});

    const [openRoomDelete, setOpenRoomDelete] = useState(false);
    const [deleteRoomData, setDeleteRoomData] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submit2Loading, setSubmit2Loading] = useState(false);
    const [submit3Loading, setSubmit3Loading] = useState(false);
    const [submit4Loading, setSubmit4Loading] = useState(false);

    const [openModal, setOpenModal] = useState(false);



    const handleOpenModal = (e) => {
        setOpenModal(true);
        roomApi.GetByKey(e.roomId).then((res) => {
            setValue2('roomId', res.data.data.id);
            setValue2('roomNumber', res.data.data.roomNumber);
            setValue2('description', res.data.data.description);
            setValue2('roomTypeKey', res.data.data.roomType.toString());
            setValue2('bedCount', res.data.data.bedCount);
            setValue2('isActive', res.data.data.isActive);
            setValue2('roomNumberCode', res.data.data.roomNumberCode)
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        );
    };
    const handleCloseModal = () => setOpenModal(false);

    const [openAddRoomModal, setOpenAddRoomModal] = useState(false);
    const handleOpenAddRoomModal = (floorId) => {
        setValue3("floorId", floorId)
        setOpenAddRoomModal(true);
    };
    const handleCloseAddRoomModal = () => {
        setOpenAddRoomModal(false);
        resetAddRoomForm();
    };

    const [openAddFloorModal, setOpenAddFloorModal] = useState(false);
    const handleOpenAddFloorModal = () => {
        // setValue3("floorId", floorId)
        setOpenAddFloorModal(true);
    };
    const handleCloseAddFloorModal = () => {
        setOpenAddFloorModal(false);
        resetAddFloorForm();
    };

    const [RoomTypes, SetRoomTypes] = useState([]);
    const GetRoomTypeDropDown = () => {
        roomApi.GetRoomTypeDropDownForRegistration()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                SetRoomTypes(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch(err => {
                if (err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
            }
            );
    };

    const schema = yup.object().shape({
        CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
        hotelId: yup.string().required("هتل را انتخاب نمایید"),
        hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
        numberOfFloor: yup.number().typeError("فرمت عدد").required("numberOfFloor ****"),
        numberOfRooms: yup.number().typeError("فرمت عدد ").required("numberOfRooms ****"),
        bedCount: yup.number().typeError("فرمت عدد").required("تعداد تخت را وارد نمایید"),
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, watch, resetField, getValues } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const schema2 = yup.object().shape({
        roomNumber: yup.number().typeError("فرمت شماره اتاق اشتباه است، عدد وارد کنید").required("شماره اتاق را وارد نمایید"),
        bedCount: yup.number().typeError("فرمت تعداد تخت اشتباه است، عدد وارد کنید").required("تعداد تخت را وارد نمایید"),
        roomTypeKey: yup.string().required("نوع اتاق را انتخاب نمایید"),
    });
    const { register: register2, setValue: setValue2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, control: control2, watch: watch2, resetField: resetField2, getValues: getValues2 } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema2),
    });


    const schema3 = yup.object().shape({
        roomNumber: yup.number().typeError("فرمت شماره اتاق اشتباه است، عدد وارد کنید").required("شماره اتاق را وارد نمایید"),
        bedCount: yup.number().typeError("فرمت تعداد تخت اشتباه است، عدد وارد کنید").required("تعداد تخت را وارد نمایید"),
        roomTypeKey: yup.string().required("نوع اتاق را انتخاب نمایید"),
    });
    const { register: register3, setValue: setValue3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, control: control3, watch: watch3, resetField: resetField3, getValues: getValues3 } = useForm({
        defaultValues: {
            roomTypeKey: "0",
            roomNumberCode: null
        },
        mode: "onChange",
        resolver: yupResolver(schema3),
    });

    const schema4 = yup.object().shape({
        number: yup.number().typeError("فرمت شماره طبقه اشتباه است، عدد وارد کنید").required("شماره طبقه را وارد نمایید"),
        name: yup.string().required("نام طبقه را وارد نمایید"),
        roomCount: yup.number().typeError("فرمت عدد").required("تعداد اتاق را وارد نمایید"),
        bedCount: yup.number().typeError("فرمت عدد").required("تعداد تخت را وارد نمایید"),
        // hotelId:yup.string().required("هتل را انتخاب نمایید")
    });
    const { register: register4, setValue: setValue4, handleSubmit: handleSubmit4, formState: { errors: errors4 }, control: control4, watch: watch4, resetField: resetField4, getValues: getValues4 } = useForm({
        defaultValues: {
        },
        mode: "onChange",
        resolver: yupResolver(schema4),
    });

    const hotelStructureId = watch("hotelStructureId")
    const onSubmit = (data) => {
        setSubmitLoading(true);

        hotelStructureApi.AutoDesignHotelStructure(data).then(async (res) => {
            if (res.data.success) {
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmitLoading(false); });

    };
    const onSubmit2 = (data) => {
        setSubmit2Loading(true);
        data.roomNumberCode = data.roomNumberCode || "";
        const newData = {
            'id': data.roomId,
            'roomNumber': data.roomNumber,
            'description': data.description,
            'roomTypeKey': data.roomTypeKey,
            'bedCount': data.bedCount,
            'isActive': data.isActive,
            'applayToAll': data.applayToAll,
            'roomNumberCode': data.roomNumberCode,
            'editReserves': data.editReserves
        }
        roomApi.Update(newData).then(async (res) => {
            if (res.data.success) {
                handleCloseModal();
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmit2Loading(false); });
    }
    const onSubmit3 = (data) => {
        setSubmit3Loading(true);
        roomApi.Add(data).then(async (res) => {
            if (res.data.success) {
                handleCloseAddRoomModal();
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmit3Loading(false); });;
    }

    const onSubmit4 = (data) => {
        setSubmit4Loading(true);
        floorApi.AutoDesignFloor(data, hotelStructureId).then(async (res) => {
            if (res.data.success) {
                handleCloseAddFloorModal();
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => { setSubmit4Loading(false); });
    }

    const handleOpenFloorDelete = (data) => {
        setOpenFloorDelete(true);
        setDeleteFloorData(data)
    };
    const handleOpenRoomDelete = (data) => {
        setOpenRoomDelete(true);
        setDeleteRoomData(data)
    };

    const handleDeleteFloor = () => {
        floorApi.SoftDelete(deleteFloorData?.floorId).then(async (res) => {

            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                //   refreshGrid(true);
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => setOpenFloorDelete(false));
    };
    const handleDeleteRoom = () => {
        roomApi.SoftDelete(deleteRoomData?.roomId).then(async (res) => {

            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                //   refreshGrid(true);
                const hotelStructure = await fetchHotelStructureById(hotelStructureId);
                SetHotelStructure(hotelStructure);
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        }
        ).finally(() => setOpenRoomDelete(false));
    };

    useEffect(() => {
        GetCityDropDown();
        GetRoomTypeDropDown();
    }, []);

    const handleCityChanged = useCallback(async (id) => {
        resetField("hotelId");
        setHotelStructureIds([]);
        resetField("hotelStructureId")
        SetHotelStructure(null)

        setHotels(null);
        if (id) {
            const hotels = await fetchHotelsByCityConsistency(id);
            setHotels(
                hotels.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, []);
    const handleHotelChanged = useCallback(async (id) => {
        // resetField("");
        setHotelStructureIds([]);
        resetField("hotelStructureId")
        SetHotelStructure(null)
        if (id) {
            const hotelStructureIds = await fetchHotelStrutureDropDown(id);
            const arr = helper.DictionayToList(hotelStructureIds);
            const mappedReponse = arr.map((r) => {
                return {
                    id: r.key,
                    label: r.value
                };
            });
            setHotelStructureIds(mappedReponse);
            if (arr.length === 1) {
                setValue("hotelStructureId", arr[0].key);

                SetHotelStructure(null);
                const hotelStructure = await fetchHotelStructureById(arr[0].key);
                SetHotelStructure(hotelStructure);

            }

        }
    }, []);

    const GetCityDropDown = () => {
        staticVariablesApi.GetArabicCityConsistencyDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                const mappedReponse = arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                });
                setCities(mappedReponse);
            })
            .catch((error) => console.log(error));
    };

    const fetchHotelsByCityConsistency = async (cityConsistency) => {
        try {
            let res = await hotelApi.HotelDropDown(cityConsistency);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };

    const fetchHotelStructureById = async (id) => {
        try {
            let res = await hotelStructureApi.GetHotelStructure(id);
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };
    const handleRoomTypeChanged = (id) => { };
    const handleHotelStructureIdChanged = async (id) => {

        // resetField("");
        SetHotelStructure(null);
        if (id) {

            const hotelStructure = await fetchHotelStructureById(id);
            SetHotelStructure(hotelStructure);
        }
    };
    const resetAddRoomForm = () => {
        resetField3("floorId");
        resetField3("roomTypeKey");
        resetField3("roomNumber");
        resetField3("bedCount");
        resetField3("description");
        resetField3("roomNumberCode")
    }
    const resetAddFloorForm = () => {
        resetField4("number");
        resetField4("name")
        resetField4("description");
        resetField4("roomCount");
        resetField4("bedCount")
    }

    const fetchHotelStrutureDropDown = async (hotelId) => {
        try {
            let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };
    return (
        <Container component="main" maxWidth={false}>
            <RtlProvider>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Typography component="h1" variant="h5" mb={2}>
                        چیدمان طبقه و اتاق
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={!Cities?.length}
                                control={control}
                                options={Cities ?? []}
                                name="CityConsistency"
                                placeholder="شهر"
                                onChange={handleCityChanged}
                                disabled={!Cities?.length}
                                error={!!errors?.CityConsistency}
                                helperText={errors?.CityConsistency?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={watch("CityConsistency") && !Hotels?.length}
                                control={control}
                                options={Hotels ?? []}
                                name="hotelId"
                                placeholder="هتل"
                                onChange={handleHotelChanged}
                                disabled={!Hotels?.length}
                                error={!!errors?.hotelId}
                                helperText={errors?.hotelId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={watch("hotelId") && !hotelStructureIds?.length}
                                control={control}
                                options={hotelStructureIds ?? []}
                                name="hotelStructureId"
                                placeholder="ساختار"
                                onChange={handleHotelStructureIdChanged}
                                disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                                style={{
                                    border: "none",
                                    padding: 0,
                                }}
                                error={!!errors?.hotelStructureId}
                                helperText={errors?.hotelStructureId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField id="outlined-basic" type="number" variant="outlined" {...register("numberOfFloor")} fullWidth label="تعداد طبقه" error={!!errors?.numberOfFloor}
                                helperText={errors?.numberOfFloor?.message} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField id="outlined-basic" type="number" variant="outlined" {...register("numberOfRooms")} fullWidth label="تعداد اتاق در طبقه" error={!!errors?.numberOfRooms}
                                helperText={errors?.numberOfRooms?.message} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField id="outlined-basic" type="number" variant="outlined" {...register("bedCount")} fullWidth label="تعداد تخت" error={!!errors?.bedCount}
                                helperText={errors?.bedCount?.message} />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />چیدمان اتوماتیک</Button>
                        </Grid>
                        <Grid item xs={12}>
                            {HotelStructure !== null ? <p><b>شرکت عربی: </b>{HotelStructure?.company.map((item) => (<Box
                                component="div"
                                sx={(theme) => ({
                                    display: 'inline',
                                    m: 1,
                                })}
                            >
                                {item.name}
                            </Box>))}</p> : ""}
                        </Grid>
                    </Grid>
                    {

                        //hotelStructureId !== undefined && hotelStructureId !== "" && HotelStructure?.hotelFloorDto !== null &&
                        watch("hotelStructureId") ?
                            !HotelStructure ? <Loading /> :

                                HotelStructure?.hotelFloorDto?.length === 0 ? <p className="error">طبقات این هتل تعریف نشده است</p> : (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table border={1} cellSpacing={0} style={tableStyle}>
                                            <thead style={{ backgroundColor: '#0070c0', color: '#ffffff' }}>
                                                <tr>
                                                    <th>طبقه
                                                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                                                            <Tooltip title="افزودن طبقه" placement="top">
                                                                <IconButton onClick={() => {
                                                                    handleOpenAddFloorModal()
                                                                }}>
                                                                    <MdAdd />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Typography>
                                                    </th>
                                                    <th colSpan={HotelStructure?.hotelFloorDto[0]?.floorsRoomDto?.length}>اتاق</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: 'center' }}>
                                                {
                                                    HotelStructure?.hotelFloorDto?.map((row, index) => (
                                                        <tr key={row.floorId}>
                                                            <th key={row.number}>{row.number} <br />
                                                                <Tooltip title="افزودن اتاق" placement="top">
                                                                    <IconButton onClick={() => {
                                                                        handleOpenAddRoomModal(row.floorId)
                                                                    }}>
                                                                        <MdAdd />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="حذف طبقه" placement="top">
                                                                    <IconButton onClick={() => {
                                                                        handleOpenFloorDelete(row)
                                                                    }}>
                                                                        <MdOutlineRemove style={{ color: '#811629' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </th>
                                                            {
                                                                row.floorsRoomDto.map((roomdto, i) => (
                                                                    <td className={helper.RoomTypeBorderColor(roomdto)} key={i}
                                                                    // onClick={() => {handleOpenModal(roomdto)}}
                                                                    >
                                                                        <Typography sx={{ display: "flex", alignItems: "center" }}>
                                                                            <Tooltip title="ویرایش اتاق" placement="top">
                                                                                <IconButton onClick={() => {
                                                                                    handleOpenModal(roomdto)
                                                                                }} sx={{ color: 'IconColor.main' }}>
                                                                                    <MdEdit />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            <Tooltip title="حذف اتاق" placement="top">
                                                                                <IconButton onClick={() => {
                                                                                    handleOpenRoomDelete(roomdto)
                                                                                }}>
                                                                                    <MdOutlineRemove style={{ color: '#811629' }} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Typography>

                                                                        {<div dir='ltr'>{roomdto?.roomNumberWithCode}</div>}
                                                                        <div>
                                                                            <BedCountCircles roomdto={roomdto} />
                                                                        </div>
                                                                    </td>
                                                                ))
                                                            }
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : ""
                    }
                </form>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            ویرایش اتاق
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <form onSubmit={handleSubmit2(onSubmit2)}>
                                <input type="hidden" {...register2("roomId")} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>

                                        <RHFAutocomplete
                                            control={control2}
                                            options={RoomTypes ?? []}
                                            name="roomTypeKey"
                                            placeholder="نوع اتاق"
                                            onChange={handleRoomTypeChanged}
                                            style={{
                                                border: "none",
                                                padding: 0
                                            }}
                                            error={!!errors2?.roomTypeKey}
                                            helperText={errors2?.roomTypeKey?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField type="number" id="outlined-basic" variant="outlined" {...register2("roomNumber")} fullWidth label="شماره اتاق" InputLabelProps={{ shrink: true }} error={!!errors2?.roomNumber}
                                            helperText={errors2?.roomNumber?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <RHFAutocomplete
                                            control={control2}
                                            options={[{ id: "A", label: "A" }, { id: "B", label: "B" }]}
                                            name="roomNumberCode"
                                            placeholder="کد اتاق"
                                            onChange={handleRoomTypeChanged}
                                            style={{
                                                border: "none",
                                                padding: 0,
                                                marginBottom: 20
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register2("bedCount")} fullWidth label="تعداد تخت" InputLabelProps={{ shrink: true }} error={!!errors2?.bedCount}
                                            helperText={errors2?.bedCount?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register2("description")} fullWidth label="توضیحات" InputLabelProps={{ shrink: true }} error={!!errors2?.description}
                                            helperText={errors2?.description?.message} />
                                        <FormControlLabel
                                            control={
                                                <Controller
                                                    name="isActive"
                                                    control={control2}
                                                    defaultValue={false}
                                                    render={({ field: { value, ref, ...field } }) => (
                                                        <Checkbox
                                                            {...field}
                                                            inputRef={ref}
                                                            checked={!!value}
                                                            color="primary"
                                                            size={"medium"}
                                                            disableRipple
                                                        />
                                                    )}
                                                />
                                            }
                                            label="فعال"
                                            labelPlacement="end"
                                        />
                                        {
                                            !HotelStructure?.hasPlan && <FormControlLabel
                                                control={
                                                    <Controller
                                                        name="applayToAll"
                                                        control={control2}
                                                        defaultValue={false}
                                                        render={({ field: { value, ref, ...field } }) => (
                                                            <Checkbox
                                                                {...field}
                                                                inputRef={ref}
                                                                checked={!!value}
                                                                color="primary"
                                                                size={"medium"}
                                                                disableRipple
                                                            />
                                                        )}
                                                    />
                                                }
                                                label="تغییر تعداد تخت به کل اتاق های هم موقعیت اعمال شود"
                                                labelPlacement="end"
                                            />

                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button type="submit" variant="contained" color="secondary" disabled={submit2Loading}><BeatLoading loading={submit2Loading} color={"#e65100"} size={8} />ویرایش</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Typography>
                    </Box>
                </Modal>

                <Modal
                    open={openAddRoomModal}
                    onClose={handleCloseAddRoomModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            افزودن اتاق
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <form onSubmit={handleSubmit3(onSubmit3)}>
                                <input type="hidden" {...register3("floorId")} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <RHFAutocomplete
                                            control={control3}
                                            options={RoomTypes ?? []}
                                            name="roomTypeKey"
                                            placeholder="نوع اتاق"
                                            onChange={handleRoomTypeChanged}
                                            style={{
                                                border: "none",
                                                padding: 0
                                            }}
                                            error={!!errors3?.roomTypeKey}
                                            helperText={errors3?.roomTypeKey?.message}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField type="number" id="outlined-basic" variant="outlined" {...register3("roomNumber")} fullWidth label="شماره اتاق" InputLabelProps={{ shrink: true }} error={!!errors3?.roomNumber}
                                            helperText={errors3?.roomNumber?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <RHFAutocomplete
                                            control={control3}
                                            options={[{ id: "A", label: "A" }, { id: "B", label: "B" }]}
                                            name="roomNumberCode"
                                            placeholder="کد اتاق"
                                            onChange={handleRoomTypeChanged}
                                            style={{
                                                border: "none",
                                                padding: 0,
                                                marginBottom: 20
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register3("bedCount")} fullWidth label="تعداد تخت" InputLabelProps={{ shrink: true }} error={!!errors3?.bedCount}
                                            helperText={errors3?.bedCount?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register3("description")} fullWidth label="توضیحات" InputLabelProps={{ shrink: true }} error={!!errors3?.description}
                                            helperText={errors3?.description?.message} />
                                    </Grid>
                                    <Grid item xs={12}><Button type="submit" variant="contained" color="secondary" disabled={submit3Loading}><BeatLoading loading={submit3Loading} color={"#e65100"} size={8} />افزودن</Button></Grid>
                                </Grid>

                            </form>
                        </Typography>
                    </Box>
                </Modal>

                <Modal
                    open={openAddFloorModal}
                    onClose={handleCloseAddFloorModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            افزودن طبقه
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <form onSubmit={handleSubmit4(onSubmit4)}>
                                <input type="hidden" {...register4("floorId")} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField type="number" id="outlined-basic" variant="outlined" {...register4("number")} fullWidth label="شماره طبقه" InputLabelProps={{ shrink: true }} error={!!errors4?.number}
                                            helperText={errors4?.number?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register4("name")} fullWidth label="نام" InputLabelProps={{ shrink: true }} error={!!errors4?.name}
                                            helperText={errors4?.name?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register4("roomCount")} fullWidth label="تعداد اتاق" InputLabelProps={{ shrink: true }} error={!!errors4?.roomCount}
                                            helperText={errors4?.roomCount?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register4("bedCount")} fullWidth label="تعداد تخت" InputLabelProps={{ shrink: true }} error={!!errors4?.bedCount}
                                            helperText={errors4?.bedCount?.message} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField id="outlined-basic" variant="outlined" {...register4("description")} fullWidth label="توضیحات" InputLabelProps={{ shrink: true }} error={!!errors4?.description}
                                            helperText={errors4?.description?.message} />
                                    </Grid>
                                    <Grid item xs={12}><Button type="submit" variant="contained" color="secondary" disabled={submit4Loading}><BeatLoading loading={submit4Loading} color={"#e65100"} size={8} />افزودن</Button></Grid>
                                </Grid>

                            </form>
                        </Typography>
                    </Box>
                </Modal>

                <ConfirmationDialog
                    open={openFloorDelete}
                    handleClose={() => setOpenFloorDelete(false)}
                    func={handleDeleteFloor}

                />
                <ConfirmationDialog
                    open={openRoomDelete}
                    handleClose={() => setOpenRoomDelete(false)}
                    func={handleDeleteRoom}
                />

            </RtlProvider>
        </Container>
    )
}
export default AutoDesignHotel;